export default __webpack_public_path__ + "static/media/Logo_Trust_YAS@3x.2eff4fe3.png";